import script from "./CustomTablePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTablePage.vue?vue&type=script&setup=true&lang=js"

import "./CustomTablePage.vue?vue&type=style&index=0&id=026d90c8&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026d90c8"]])

export default __exports__